import { Observable } from 'rxjs';
import { PixDataModel, ReturnTypeModel } from '@src/core/domain/pix/return-type.model';

export abstract class PixLimitesRepository {
  abstract getLimitesPix(obj: void): Observable<ReturnTypeModel>;

  abstract getAccountLimitesPix(params: any): Observable<PixDataModel>;
}
